import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';
import { HeritageSeal } from '@/components/BrandMark';
import { ArrowRight, Instagram, Globe } from 'lucide-react';

export default function AmbassadorLandingPage() {
  const { code } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/ambassador/public/${code}`);
        setA(data.ambassador);
        // Store code so checkout auto-applies it
        try { localStorage.setItem('h_ref_code', code.toUpperCase()); } catch { /* ignore */ }
      } catch { setErr(true); }
    })();
  }, [code]);

  if (err) return <div className="max-w-xl mx-auto p-16 text-center"><HeritageSeal size={60} /><div className="h-eyebrow mt-4">Not found</div><div className="h-display text-3xl mt-2" style={{ color: 'var(--heritage-plum)' }}>Ambassador not found</div><Link to="/store" className="h-btn mt-6">Shop the store</Link></div>;
  if (!a) return <div className="p-16 text-center opacity-70" style={{ color: 'var(--heritage-plum)' }}>Loading…</div>;

  return (
    <div className="max-w-3xl mx-auto px-6 py-14 text-center">
      <div className="w-24 h-24 rounded-full overflow-hidden mx-auto" style={{ background: 'rgba(75,24,56,0.1)' }}>
        {a.avatar_url ? <img src={a.avatar_url} alt={a.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center h-display text-4xl" style={{ color: 'var(--heritage-plum)' }}>{(a.name || '?')[0]}</div>}
      </div>
      <div className="h-eyebrow mt-6">Heritage Ambassador</div>
      <h1 className="h-display text-5xl mt-2" style={{ color: 'var(--heritage-plum)' }}>{a.name}</h1>
      {a.bio && <p className="opacity-85 mt-4 max-w-xl mx-auto" style={{ color: 'var(--heritage-plum)' }}>{a.bio}</p>}

      <Panel className="p-6 mt-8">
        <div className="h-eyebrow">Your Heritage code</div>
        <div className="h-display text-4xl mt-2" style={{ color: 'var(--heritage-plum)' }}>{a.referral_code}</div>
        <div className="text-sm opacity-85 mt-1" style={{ color: 'var(--heritage-plum)' }}>{a.discount_percent}% off at checkout — auto applied when you shop from here.</div>
        <Link to="/store" className="h-btn mt-4 inline-flex items-center">Shop the store <ArrowRight size={14} className="ml-1.5" /></Link>
      </Panel>

      {(a.socials?.instagram || a.socials?.website) && (
        <div className="mt-6 flex items-center justify-center gap-4 text-sm" style={{ color: 'var(--heritage-plum)' }}>
          {a.socials?.instagram && <a href={`https://instagram.com/${a.socials.instagram.replace('@', '')}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 opacity-80 hover:opacity-100"><Instagram size={13} /> {a.socials.instagram}</a>}
          {a.socials?.website && <a href={a.socials.website} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 opacity-80 hover:opacity-100"><Globe size={13} /> website</a>}
        </div>
      )}
    </div>
  );
}
